import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const menuApi = tokenSlice.injectEndpoints({
    reducerPath: 'menu',
    baseQuery: createBaseQuery(),
    endpoints(builder) {
        return {
            getMenu: builder.query({
                query: () => {
                    return {
                        url: 'Menu/GetUserMenusWithChildren',
                        method: 'GET'
                    }
                }
            }),
            getMenuWithPriveleges: builder.query({
                query: () => {
                    return {
                        url: "Menu/GetUserMenusWithPrivileges",
                        method: 'GET'
                    }
                }
            }),
            getAdditionalPrivilegeAccess: builder.query({
                query: () => {
                    return {
                        url: "Menu/GetAdditionalPrivilegeAccess",
                        method: 'GET'
                    }
                },
                providesTags: ["Menu"],
            }),
        }
    }
})

export const { useGetMenuQuery, useGetMenuWithPrivelegesQuery, useGetAdditionalPrivilegeAccessQuery } = menuApi;
export { menuApi };
